import React from 'react';
import { ProgressBar, ListGroup, Badge } from 'react-bootstrap';

const ChecklistSidebar = ({ checklist }) => {
  const numComplete = checklist.filter(item => item.complete).length;
  const percent = Math.round((numComplete / checklist.length) * 100);
  return (
    <div className="glass-card p-3 mb-4 premium-shadow animate-fade-in checklist-sidebar">
      <h5 className="mb-3 gradient-text">Review Checklist</h5>
      <ProgressBar now={percent} label={`${percent}%`} animated variant="info" className="mb-3 animated-gradient-bar" />
      <ListGroup variant="flush">
        {checklist.map((item, idx) => (
          <ListGroup.Item key={idx} className="d-flex align-items-center bg-transparent">
            <span className={item.complete ? 'text-success fw-bold' : 'text-danger fw-bold'}>
              {item.complete ? '✔' : '✗'}
            </span>
            <span
              className={
                'ms-2 flex-grow-1' +
                (item.isPublished === false ? ' text-danger fw-bold' : '')
              }
              dangerouslySetInnerHTML={{ __html: item.label }}
            />
            {item.required && <Badge bg={item.complete ? 'success' : 'warning'}>{item.complete ? 'Done' : 'Required'}</Badge>}
          </ListGroup.Item>
        ))}
      </ListGroup>
    </div>
  );
};

export default ChecklistSidebar;
